import { designSystemColors } from '@klv/shared/styles/colors';

const tileHoverColors = {
  lavender: designSystemColors.lavender,
  sage: designSystemColors.sage,
  lemon: designSystemColors.lemon,
};

const tileList = {
  timing: '300ms',
  light: {
    backgroundColor: designSystemColors.lightSand,
    tileColor: designSystemColors.white,
    tileHover: tileHoverColors,
  },
  dark: {
    backgroundColor: designSystemColors.charcoal,
    tileColor: designSystemColors.white,
    tileHover: tileHoverColors,
  },
};

export default tileList;
